import type { Dayjs } from "dayjs";
import Decimal from "decimal.js";

// 解析アーカイブの先頭 (タスクH 再作成+バックフィル4ini後は 20260717-21 ランの
// 解析先頭)。最新初期値からPT=96まで常に開ける深さを確保済み。
export const MSG_ANALYSIS_START = "2026-07-16T21:18:00";

export function usesMsgAnalysis(ft: Decimal) {
    // 現行 MSGW と同様、初期時刻そのものは解析画像を使う。
    return ft.lte(0);
}

export function msgTargetKey(initial: Dayjs, ft: Decimal) {
    const target = initial.add(Math.round(ft.toNumber() * 60), "minute");
    const deci = Math.round(target.minute() / 6);
    return {
        target,
        key: `${target.format("YYYYMMDD-HH")}.${deci}`,
    };
}

export function msgForecastKey(ft: Decimal) {
    return ft.toFixed(1).padStart(4, "0");
}
